import {
  Color,
  ImageCoverView,
  ImageScaleView,
  MultiplyFilter,
  TintFilter,
} from '@play-co/timestep-core/ui';
import bitmapFonts from 'src/lib/bitmapFonts';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import sounds from 'src/lib/sounds';
import ButtonScaleView, {
  ButtonScaleViewOpts,
} from 'src/lib/ui/components/ButtonScaleView';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { LockedReason } from '../popups/PopupFeatureDisabled';

export type SideButtonFeatures = 'duo' | 'visitFriend';

export class SideButton extends ButtonScaleView {
  private lockedIcon: ImageCoverView;
  private type: SideButtonFeatures;
  private onUnlockedClick: () => Promise<void>;
  private lockedReason: LockedReason;
  private image: ImageScaleView;
  private plate: ImageScaleView;

  constructor(
    opts: ButtonScaleViewOpts & {
      type: SideButtonFeatures;
      icon: {
        image: string;
        width?: number;
        height?: number;
        offsetX?: number;
        offsetY?: number;
      };
      label: string;
    },
  ) {
    const icon = opts.icon;
    const label = opts.label;

    delete opts.icon;
    delete opts.label;

    super({
      width: 159,
      height: 168,
      centerOnOrigin: true,
      pressedOffsetY: 5,
      ...opts,
    });

    this.type = opts.type;
    this.onUnlockedClick = opts.onClick;

    this.image = new ImageScaleView({
      superview: this,
      x: this.style.width * 0.5 + (icon.offsetX ?? 0),
      y: this.style.height * 0.5 + (icon.offsetY ?? 0),
      width: 104,
      height: 110,
      centerOnOrigin: true,
      ...icon,
    });

    this.plate = new ImageScaleView({
      superview: this,
      image: 'assets/ui/shared/frames/icon_plate.png',
      x: 90.5,
      y: 148,
      width: 159,
      height: 58,
      centerOnOrigin: true,
    });

    new LangBitmapFontTextView({
      superview: this.plate,
      width: 150,
      height: 47,
      align: 'center',
      verticalAlign: 'center',
      size: 22,
      color: '#b68351',
      wordWrap: false,
      font: bitmapFonts('Body'),
      localeText: () => label,
    });

    this.lockedIcon = new ImageCoverView({
      superview: this,
      image: 'assets/ui/shared/icons/footer_locked.png',
      width: 50,
      height: 59,
      x: this.style.width - 55,
      y: 10,
      visible: false,
    });
  }

  public setLocked(locked: boolean, reason?: LockedReason) {
    if (locked) {
      const filter = new TintFilter(new Color(0, 0, 0, 0.2));
      this.image.setFilter(filter);
      this.plate.setFilter(filter);
    } else {
      this.image.removeFilter();
      this.plate.removeFilter();
    }
    this.lockedIcon.updateOpts({ visible: locked });
    this.onClick = locked ? this.onLocked : this.onUnlockedClick;
    this.lockedReason = reason;
  }

  private async onLocked() {
    sounds.sfx.play('ok');

    await openPopupPromise('popupFeatureDisabled', {
      feature: this.type,
      reason: this.lockedReason,
    });

    sounds.sfx.play('cancel');
  }
}
